import React from 'react';
import { useParams } from 'react-router-dom';
import loader from "../../../../assets/static/logo/loader.gif";
import ShufflingText from '../ShufflingText/ShufflingText';
import * as loaderLottie from '../../../../assets/8parts-logo.json'
import Lottie from 'react-lottie';
import animationData from "../../../../assets/JsonFiles/8xpartsLogoJson.json";
import { useInstance } from '../../../../context/instance.context';
import ndcsLoader from "../../../../images/processing.svg"



const QuotationLoader = ({ processing, selectedProcess, globeLoader, isLoading, isQuaoarLoaderData }) => {


  const { name, allInstanceData } = useInstance();
  const isNdcs = name == allInstanceData.NDCS;


  return (
    <>
      {
        (isLoading) ? (
          <div className="processing1" style={{ zIndex: 10001 }}>
            {!isNdcs ? <div>
              {/* <img src={loader} alt="instant quote" /> */}
              <Lottie options={{
                loop: true,
                autoplay: true,
                animationData: loaderLottie,
                rendererSettings: {
                  preserveAspectRatio: 'xMidYMid slice'
                }
              }}
                width={300}
              />
            </div> : <div>
              <img src={ndcsLoader} />
            </div>}
            <h1>
              {isQuaoarLoaderData?.currentStatus === "initial-loading" ? (
                <>Preparing your files for analysis...</>
              ) : isQuaoarLoaderData?.isLoading && isQuaoarLoaderData?.jobsInQueue > 0 ? (
                <>
                  Analyzing your uploaded files. This may take a few moments as it's a resource-intensive process.
                  <br />
                  Thank you for your patience.
                  <br />
                  {/* <strong>Estimated time:</strong>{' '}
                  ~{(() => {
                    const totalSeconds = isQuaoarLoaderData.jobsInQueue * 3;
                    const minutes = Math.floor(totalSeconds / 60);
                    const seconds = totalSeconds % 60;
                    return `${minutes > 0 ? `${minutes} minute${minutes > 1 ? 's' : ''}` : ''}${minutes > 0 && seconds > 0 ? ' and ' : ''
                      }${seconds > 0 ? `${seconds} second${seconds > 1 ? 's' : ''}` : ''}`;
                  })()} */}
                </>
              ) : (
                <>Almost there! Just putting on the final touches...</>
              )}
            </h1>

            <div style={{ minHeight: 90 }}>
              <ShufflingText />
            </div>
          </div>
        ) : ""
      }
    </>
  );
};
export default QuotationLoader